import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ContactPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData,setFormData]=useState({
        name:"",
        email:"",
        mobile:"",
        serviceType:"",
        message:""
    })

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "mobile") {
            // Remove country code if pasted (+91 or 91)
            value = value.replace(/^\+?91/, "");
    
            // Remove leading zeros
            value = value.replace(/^0+/, "");
    
            // Remove spaces
            value = value.replace(/\s/g, "");
    
            // Only keep numeric values
            value = value.replace(/\D/g, "");
    
            // Limit to 10 digits
            value = value.slice(0, 10);
        }

        // if (name === "borrowAmount" || name === "monthlySalary") {
        //     value = value.replace(/\D/g, ""); // Remove non-numeric characters
        //     value = formatINR(value); // Format with INR commas
        // }

        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Show loader
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/contact`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            })
            const res = await response.json();
            if (response.ok) {
                toast.success("Details sent, Our team will contact you soon", {
                    position: "top-center",
                    autoClose: 3000
                })
                setFormData({
                    name:"",
                    email:"",
                    mobile:"",
                    serviceType:"",
                    message:""
                })
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 3000
            })
            setLoading(false);
        }
        // Simulate an API request (replace with actual API call)

    };
    return (
        <>
            <div className="other-pages-main-section contact-page-fin">
                <h2 className="other-pages-title">Contact Us</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/contact-loan-experts")} style={{ cursor: "pointer" }}>Contact</span>
                </p>
            </div>
            <section className="contact-page-smco">
                <div className="contact-page-smco-container">
                    <div className="contact-page-smco-left">
                        <h3>Contact Us</h3>
                        <form onSubmit={handleSubmit}>
                            <label>Name</label>
                            <input type="text" name="name" value={formData.name} className="contact-page-smco-input" onChange={handleChange} placeholder="Your Name" />

                            <label>Email</label>
                            <input type="email" name="email" value={formData.email} className="contact-page-smco-input" onChange={handleChange} placeholder="Your Email" />

                            <label>Phone Number</label>
                            <input type="text" name="mobile" value={formData.mobile} className="contact-page-smco-input" placeholder="Your Number" onChange={handleChange}/>

                            <label>Service Type</label>
                            <select className="contact-page-smco-input" name="serviceType" value={formData.serviceType} onChange={handleChange}>
                                <option value="">Select Service</option>
                                <option value="Audit & Assurance Services">Audit & Assurance Services</option>
                                <option value="Financial Hygiene & Managed Accounting">Financial Hygiene & Managed Accounting</option>
                                <option value="Indian Tax Advisory (Direct & Indirect)">Indian Tax Advisory (Direct & Indirect)</option>
                                <option value="Capital & Lending Solutions">Capital & Lending Solutions</option>
                                <option value="Corporate Advisory & Virtual CFO">Corporate Advisory & Virtual CFO</option>
                                <option value="Registration and Certifications">Registration and Certifications</option>
                            </select>

                            <label>Message</label>
                            <textarea className="contact-page-smco-input" placeholder="Your Message" name="message" value={formData.message} onChange={handleChange}></textarea>

                            <button type="submit" className="contact-page-smco-button">
                            {loading ? <span className="spinner"></span> : "Submit"}
                            </button>
                        </form>
                    </div>
                    <div className="contact-page-smco-right">
                        <h3>Office Information</h3>
                        <p><strong>Office Timing:</strong> 10:00 AM - 9:00 PM</p>
                        <p><strong>Address:</strong> Office No. 5, Building No. 4, Sector 2, Shanti Garden, Mira Road East, Mumbai 401107</p>
                        <p><strong>Phone:</strong> +91-8369698298</p>
                        <p><strong>Email:</strong> business@krsfinsolutions.com</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactPage;
